export type RequestStatus = 'init' | 'success' | 'error' | 'loading';

export enum statusFacilitator {
  active = 'active',
  inactive = 'inactive',
  preRegistered = 'pre_registered',
  registered = 'registered',
  disabled = 'disabled',
  false = 'false',
  true = 'true',
}

export interface FreeCompanies {
  id: string;
  name: string;
  facilitator_id: string | null;
  group_id: string | null;
  allied_id: string | null;
  company_name: string;
  show_company: boolean;
  telephone: string;
  created_At: Date;
}

export interface AllCompanies {
  id: string;
  name: string;
  facilitator: AllCompaniesFacilitator | null;
  group: AllCompaniesGroup | null;
  allied: AllCompaniesAllied | null;
  company_name: string;
  show_company: boolean;
  telephone: string;
}

export interface ZohoLog {
  id: string;
  zoho_id: string;
  ID_App: string;
  syncedAt: Date;
  syncedResult: string;
  syncedAction: string;
  syncedMessage: string;
  telephone: string;
  Nombres: string;
  Apellidos: string;
  Tel_fono: string;
  Pa_s?: string;
  Name?: string;
  Organizaci_n?: string;
  Agencia?: string;
  Facilitador?: string;
  Status_reto_y_actividad?: string;
  Status_general?: string;
  Reto_y_actividad?: string;

  created_At: Date;
}


export interface AllCompaniesAllied {
  id: string;
  name: string;
}

export interface AllCompaniesGroup {
  id: string;
  name: string;
}

export interface AllCompaniesFacilitator {
  id: string;
  name: string;
}


export interface Allied {
  _id: string;
  name_ally: string;
  category: Categories;
  country: string;
  start_date: string;
  ending_date: string;
  ally_level: AllyLevel;
  status: boolean;
  created_At: Date;
  updated_At: Date;
  number_companies: number;
  number_facilitators: number;
  proximate: boolean;
  disabled: boolean;
}

enum Categories {
  type1 = 'Microfinanciera',
  type2 = 'ONG local',
  type3 = 'ONG international',
  type4 = 'CAM s',
  type5 = 'Incubadora',
  type6 = 'Banco',
  type7 = 'Sector público',
  type8 = 'Sector Privado',
  type9 = 'Academia',
  type10 = 'Cooperación Internacional',
}

enum AllyLevel {
  lvl1 = 'Bronce',
  lvl2 = 'Plata',
  lvl3 = 'Oro',
}

export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
}

export interface Facilitator {
  agency: string;
  agency_name: string;
  country: string;
  created_At: Date;
  credential_delivery: { email: true };
  email: string;
  fullName: string;
  fullname: string;
  id_allied: string;
  lada: string;
  names: string;
  notifications: [];
  password: string;
  phone_number: string;
  picture?: string;
  pre_registered: boolean;
  refresh_token: string;
  send_credentials: boolean;
  status: statusFacilitator;
  surnames: string;
  token_notifications?: TokenNotifications;
  updated_At: Date;
  __v: number;
  _id: string;
}

export interface TokenNotifications {
  device: string;
  system: string;
  token: string;
}

export interface Group {
  _id: string;
  id_facilitator: string;
  id_allied: string;
  group_name: string;
  start_date: string;
  ending_date: string;
  status: boolean;
  created_At: Date;
  updated_At: Date;
}

export interface facilitatorList {
  allied_user: string;
  created_At: string;
  ending_date: string;
  facilitator_user: string;
  group_name: string;
  id_allied: string;
  id_facilitator: string;
  id_group: string;
  start_date: string;
  status: boolean;
  updated_At: string;
  _id: string;
}

export interface Oportunitie {
  created_At: string;
  file: string;
  file_name: string;
  interested: [];
  notice: string;
  opportunity_description: string;
  opportunity_title: string;
  pdf: string;
  picture: string;
  select_group: string;
  select_theme: string;
  type: string;
  updated_At: Date;
  url: string;
  video: string;
  _id: string;
}

export interface notification {
  notification_description: string;
  notification_image?: string;
  notification_title: string;
  path_file: string;
  programming: string;
  reated_At: Date;
  schedule_notification: {
    date: Date;
    hour: string;
  };
  token_notification?: Array<string>;
  type: target;
  updated_At?: Date;
  __v?: 0;
  _id?: string;
}

enum target {
  all = 'all',
  organizations = 'allies',
  faciltators = 'facilitators',
  companies = 'companies',
}

export enum Gender {
  masculine = 'masculine',
  feminine = 'feminine',
  other = 'other',
}

export interface Company {
  abandonment: boolean;
  active: boolean;
  company_name: string;
  country: string;
  country_iso: string;
  created_At: Date;
  diagnostic: Diagnostic;
  diagnostic_completed: boolean;
  events: any[];
  expiration_date: Date;
  genere?: Gender;
  id_allied: string;
  id_facilitator: string;
  id_group: string;
  identification_number: string;
  lada: string;
  names: string;
  notifications: NotifiactionCompany[];
  pre_registered: boolean;
  proximate: boolean;
  refresh_token: string;
  registered: boolean;
  selling: SellingCompany;
  send_credentials: boolean;
  start_year: string;
  status: boolean;
  general_status?: string;
  progress_status?: string;
  surnames: string;
  telephone: string;
  token_notifications: TokenNotificationCompany;
  updated_At: Date;
  verification_code: string;
  picture_profile?: string;
  __v: number;
  _id: string;
}

export interface Diagnostic {
  improve_areas: InprovedAreas;
  monthly_income: MonthlyInconme;
  workers: Workers;
  recieved_financing: boolean;
}

export interface InprovedAreas {
  financial_control: boolean;
  increase_production: boolean;
  sales_skills: boolean;
  prices: boolean;
  save_expenses: boolean;
  keep_customers: boolean;
  new_way_selling: boolean;
  manage_time: boolean;
  manage_inventory: boolean;
}

export interface MonthlyInconme {
  max: number;
  min: number;
}

export interface Workers {
  full_time?: number;
  part_time?: number;
}

export interface NotifiactionCompany {
  id_notifications: string;
  read: boolean;
  _id: string;
}

export interface SellingCompany {
  products: boolean;
  resale: boolean;
  services: true;
}

export interface TokenNotificationCompany {
  device: string;
  system: string;
  token: string;
}

export type StatusGroup = 'Activo' | 'Próximamente' | 'Inactivo' | 'unset';
